import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildAccidents } from './accidentsModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Accidents({ person, showSummary = true }) {
    const model = useMemo(() => buildAccidents(person), [person])
    const { summary, rows } = model
    if (!rows.length) return <div className={styles.calmLine}>No accidents found.</div>
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    <Badge tone='neutral'>{plural(summary.count, 'accident')}{summary.latestYear ? ` · latest ${summary.latestYear}` : ''}</Badge>
                    {summary.alcohol > 0 && <Badge tone='declined' dot>{summary.alcohol} with alcohol or drugs</Badge>}
                    {summary.fatal > 0 && <Badge tone='declined'>{summary.fatal} fatal</Badge>}
                    {summary.cited > 0 && <Badge tone='watch'>{summary.cited} with the owner cited</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Most accident records only give the date, state and vehicles. Open one for the crash report details when Lexis has them.
            </div>
            <RecordList items={rows} />
        </div>
    )
}
